// removed by extract-text-webpack-plugin
module.exports = {"emptyCartMessageIcon":"_25odgF6UCxetS4FLisrfhW","emptyCartMessageContainer":"VDdY7sVUVCkUAx50A7Ihm","emptyCartMessageTitle":"_1o2W0cQHgNZaTIU8mv8zTS","emptyCartMessageSecondary":"_25JnzhbEIajBt3Rp_ptXZB","emptyCartMessageButton":"_194mHGzSfLvbKml0BIbouV","messageSecondary":"_26Y_SPaoefEJCM-jiiEAg0","message":"_2D4TJZsorW0w5VAtyLPLha","messageContainer":"_2lggcKBFCwFLP8k_XEvs87"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/EmptyCart/style.scss
// module id = 873
// module chunks = 0